import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, NgZone, Inject,HostListener, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Ng2DeviceService } from 'ng2-device-detector';
import {timer} from 'rxjs/observable/timer'
import { Body } from '@angular/http/src/body';
import { Subject } from 'rxjs';
import { HeaderComponent } from '../header/header.component';
// import * as THREE from 'three';
// import NET from 'vanta/dist/vanta.net.min';

declare var videojs: any;
declare var jquery: any;
declare var $: any;
declare var THREE: any;
declare var VANTA: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit, OnDestroy  {
   
  user: User = new User();
  constructor(private authService: AuthService, private route: ActivatedRoute,
              private router: Router, zone: NgZone, @Inject(DOCUMENT) private document: Document,
              private deviceService: Ng2DeviceService) {

  }
  
  ngOnInit() {
    
      // var pUsername = this.route.snapshot.paramMap.get('username');

      var pUsername = '';

      this.route.queryParamMap.subscribe(params => {
        pUsername = params.get('username');           // ?username=123 → "123"
      });
      
      const temp = this.authService.login_get(pUsername, '').subscribe((user) => {
        // console.log(user)
        
        if (user.status === 'error') {
          this.router.navigate(['login']);
        }else {
          this.router.navigate(['']);
        }
      }, err => {
        
      });
  }

  ngOnDestroy() {
   
  }
}


// WEBPACK FOOTER //
// ./src/app/components/signin/signin.component.ts